export default {
  setFeatureFlags({ commit, getters }, payload) {
    commit('SET_TOGGLES', payload.toggles);

    window.toggles = getters.getToggles;
  },
};
